<template>
  <div>
    <div v-if="loading" class="dw-loading">
      <b-spinner small></b-spinner> Loading...
    </div>
    <div v-else-if="!failures.length" class="dw-empty">No delivery failures in the last {{ daysRange }} days.</div>
    <!-- a feed, not a table: the reason is the only column anyone actually
         reads here, and as a nowrap table cell it was clipped to
         "sms: Phone is currently unrea..." -- the failure was legible in
         every column except the one that says why it failed. giving the
         reason the full row width and letting it wrap costs no more
         vertical space than the table row it replaces. -->
    <div v-else class="dw-feed">
      <button
        v-for="f in failures"
        :key="f.key"
        type="button"
        class="dw-feed-item"
        @click="goToAlerts"
      >
        <span class="dw-feed-row-top">
          <span class="dw-feed-title">{{ f.headline }}</span>
          <span class="dw-feed-time">{{ f.timeLabel }}</span>
        </span>
        <span class="dw-feed-reason">{{ f.reason }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { recentFailures } from '../../utils/alerts_analytics'

export default {
  name: 'widget_recent_delivery_errors',
  props: {
    // shared across every alert-detail widget by main_dashboard.vue's
    // load_alerts_detail(), so this widget costs no API call of its own.
    alerts: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    daysRange: { type: Number, required: true },
  },
  computed: {
    failures() {
      return recentFailures(this.alerts, 5).map(f => ({
        ...f,
        // vehicle + alert type identify the row; joined into one heading so
        // the reason below gets the whole width to itself. an alert with no
        // vehicle (a trip-level notification) just shows its type.
        headline: [f.vehicle_id, f.alert_type].filter(Boolean).join(' · ') || 'Delivery failure',
        timeLabel: f.processed_time ? moment(f.processed_time).format('MM/DD h:mma') : '',
      }))
    },
  },
  methods: {
    goToAlerts() {
      this.$router.push({ name: 'alerts_dashboard' }).catch(() => {})
    },
  },
}
</script>
